<template>
    <div>
        <div class="accordion">
            <!--標頭-->
            <div class="menu-title">
                主選單列表
                <small>
                    MENU
                </small>
            </div>
            <!--第一層-->
            <ul class="list-unstyled" role="tablist">
                <template v-for="(item,index) in menu">
                    <template v-if="item.SubList != null">
                        <!--有次分類時(第一層類別)-->
                        <li :key="index">
                            <button class="accordion-btn gradient" v-b-toggle="'accordion-' + index">
                                <b-icon class="accordion-arrow" icon="caret-right-fill"></b-icon>
                                <span v-html="item.title"></span>
                                <b-badge v-if="item.construction" variant="warning">尚未開發</b-badge>
                            </button>
                            <b-collapse
                                tag="ul"
                                :id="'accordion-' + index"
                                accordion="first-accordion"
                                role="firstPanel"
                                class="list-unstyled"
                                :visible="isCheckAct(item.SubList)">
                                <!-- 第二層-->
                                    <template v-for="(secondItem, secondIndex) in item.SubList">
                                        <template v-if="secondItem.SubList != null">
                                            <li :key="secondIndex">
                                                <button
                                                    class="accordion-btn"
                                                    v-b-toggle="'secondAccordion-' + index + secondIndex">
                                                    <b-icon
                                                        class="accordion-arrow"
                                                        icon="caret-right-fill">
                                                    </b-icon>
                                                    
                                                    <span v-html="secondItem.title"></span>
                                                    <b-badge
                                                        v-if="secondItem.construction"
                                                        variant="warning">
                                                        尚未開發
                                                    </b-badge>
                                                </button>
                                                <b-collapse
                                                    tag="ul"
                                                    :id="'secondAccordion-' + index + secondIndex"
                                                    accordion="second-accordion"
                                                    role="secondpanel"
                                                    class="list-unstyled"
                                                    :visible="isCheckAct(secondItem.SubList)">
                                                    <!-- 第三層 -->
                                                    <li
                                                        v-for="(thirdItem, thirdIndex) in secondItem.SubList"
                                                        :key="thirdIndex"
                                                        :class="{ active: thirdItem.PJ_ID == $route.query.PJID  /*isCheckAct(null,1,thirdItem.to)*/ }">
                                                        <a
                                                            class="accordion-btn"
                                                            style="padding-left: 52px"
                                                            :href="(thirdItem.to?thirdItem.to : item.to)+'?PJID='+thirdItem.PJ_ID + '&modal='+thirdItem.modal"
                                                            @click="getPageLocation()">
                                                            <span v-html="thirdItem.title"></span>
                                                            <b-badge
                                                                v-if="thirdItem.construction"
                                                                variant="warning">
                                                                尚未開發
                                                            </b-badge>
                                                        </a>
                                                    </li>
                                                </b-collapse>
                                            </li>
                                        </template>
                                        <template v-else>
                                            <!--無次分類時(第二層)-->
                                            <li :key="secondIndex"
                                                :class="{ active:secondItem.PJ_ID == $route.query.PJID}">
                                                <a
                                                class="accordion-btn"
                                                style="padding-left: 36px"
                                                :href="(secondItem.to?secondItem.to : item.to) +'?PJID='+secondItem.PJ_ID+'&modal='+secondItem.modal">
                                                
                                                    <span v-html="secondItem.title"></span>
                                                    <b-badge
                                                        v-if="secondItem.construction"
                                                        variant="warning"
                                                        >尚未開發
                                                    </b-badge>
                                                </a>
                                            </li>
                                        </template>
                                    </template>
                            </b-collapse>
                        </li>
                    </template>
                    <template v-else>
                        <!--無次分類時(第一層類別)-->
                        <li :key="index">
                            <a
                                class="accordion-btn gradient"
                                style="padding-left: 36px"
                                :href="item.to">
                                {{ item.title }}
                            </a>
                        </li>
                    </template>    
                </template>
            </ul>
        </div>
    </div>
</template>
<script>
export default{
    data() {
        return{
            //所在頁面
            pageLocation: window.location.pathname+ window.location.search,
            //
            typeId: '',
            //
            classesId: '',
            //
            thirdId: '' ,
            //
            page: 'home' ,
            //前一頁頁面
            oldpageLocation: null ,
            // 
            userOldpage: false,
            //
            menu:[],
            //
            nacActive:[],
            //
            navTitle: null,
            //
            backgroundActive: [],
            //
            phoneBarOpen: false,
            //
            firstLevelExpanded: null,
            //
            secondLevelExpanded: null,
            //API-類別
            apiProject: (data) =>
                this.userRequest.post("bicd/Project", data),

        }
    },
    mounted(){
        //初始化
        this.init();
    },
    watch: {
        '$route'() {
            //初始化
            this.init();
        },
    },
    methods:{
        //初始化
        init(){
            let json = {
                TYPE: "GET_SIDEBAR_OPTION",
            };
            this.FunctionToken(this.GetSideBar, json);
            
        },
        //取得類別資料
        GetSideBar(data){
            this.apiProject(data)
                .then((res) => {
                    let json = JSON.parse(res.data);
                    if (json.Status) {
                        let jsonData = JSON.parse(json.Data);
                        this.menu = jsonData;
                        //新增登出選項
                        this.menu.push({
                            PJ_ID:null,
                            PJ_LEVEL:null,
                            SubList: null,
                            construction:false,
                            title:"登出",
                            to: '/backend/Logout',
                        });
                    }  
                })
                .catch((err) => {
                    console.log("ErorrFunction: GetSideBar /n"+err);
                });
        },
        
        //判斷側邊欄位摺疊
        isCheckAct(subList){
            //判斷子列表是否有包含目前編號            
            var isAct = false;
            if(subList.filter(x=> x.PJ_ID == this.$route.query.PJID).length > 0){
                return true;
            }

            if(!isAct){
                subList.forEach(item => {
                    if(item.SubList){
                        if(item.SubList.filter(x => x.PJ_ID == this.$route.query.PJID).length > 0){
                            isAct = true;
                            return;
                        }
                    }
                });                        
            }
            return isAct;
        }
    }
}
</script>
